<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
  <div fxLayout="row wrap" fxLayout.lt-sm="column">
      <div fxFlex="100" class="pr-1"><br></div>

      <div fxFlex="100">

        <!--
          <mat-form-field style="margin: 20px;">
              <mat-label>Pesquisar: </mat-label>
              <input [imask]="maskUpper" matInput placeholder="Pesquisa..." autocomplete="on"
                  (keyup)="searchBy_UsingDebounce($event.target.value)" [(ngModel)]="searchInput"
                  [ngModelOptions]="{standalone: true}">
              <button mat-button mat-icon-button matSuffix (click)="searchInput='';getPage(1, pageSize)"
                  [color]="'warn'" *ngIf="searchInput">
                  <mat-icon>close</mat-icon>
              </button>
          </mat-form-field>

          -->

          <mat-form-field appearance="fill">
              <mat-label>Ordenar</mat-label>
              <mat-select [(value)]="selectedOrdem" (selectionChange)="searchBy_UsingDebounce(this.searchInput)">
                  <mat-option value="NENHUM">Inclusão</mat-option>
                  <mat-option value="NOME">Nome</mat-option>
                  <mat-option value="TAMANHO">Tamanho</mat-option>
                  <!-- <mat-option value="LOGIN">Último login</mat-option> -->
              </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
              <mat-label>Ordenar</mat-label>
              <mat-select [(value)]="selectedDirect" (selectionChange)="searchBy_UsingDebounce(this.searchInput)">
                  <mat-option value="ASC">Ascendente </mat-option>
                  <mat-option value="DESC">Descendente </mat-option>
              </mat-select>
          </mat-form-field>

          <span fxflex="" style="flex: 1 1 0%; box-sizing: border-box;"></span>
          <button mat-icon-button style="margin-left: auto;" *ngIf="this.view!=='list'" (click)="this.view = 'list'">
              <mat-icon>view_list</mat-icon>
          </button>
          <button mat-icon-button style="margin-left: auto;" *ngIf="this.view!=='comfy'"
              (click)="this.view = 'comfy'">
              <mat-icon>view_comfy</mat-icon>
          </button>
          <button mat-icon-button style="margin-left: auto;" *ngIf="this.view!=='module'"
              (click)="this.view = 'module'">
              <mat-icon>view_module</mat-icon>
          </button>
          <button mat-raised-button color="primary" (click)="this.createFatDoctoIDI(this.data?.payload);$event.preventDefault();">
              <mat-icon>add_circle</mat-icon>
          </button>
      </div>

      <div fxFlex="100">
          <div fxLayout="row wrap">
              <div *ngFor="let itemDeclaracaoImportacao of (this.pageObject$ | async)?.content" fxFlex="{{this.viewSize()}}"
                  fxFlex.gt-sm="{{this.viewSize()}}" fxFlex.sm="{{this.viewSize()}}">
                  <mat-card class="user-card p-0">
                      <mat-card-title>
                          <div class="card-title-text">
                              <div matToolTip="">
                                {{ (itemDeclaracaoImportacao?.id??'') + " - " + (itemDeclaracaoImportacao?.status??'Declaração de importação') }}                               
                              </div>
                              <span fxFlex></span>
                              <button mat-icon-button [matMenuTriggerFor]="userMenu" class="">
                                  <mat-icon class="">more_vert</mat-icon>
                              </button>
                              <mat-menu #userMenu="matMenu">
                                  <button mat-menu-item color="primary" class="mr-1"
                                      (click)="this.editDoctoIDI(itemDeclaracaoImportacao, this.data?.payload)">
                                      <mat-icon color="primary">edit</mat-icon>Editar
                                  </button>
                                  <button mat-menu-item  (click)="this.delete(itemDeclaracaoImportacao)">
                                      <mat-icon color="warn">delete</mat-icon>Deletar
                                  </button>
                               
                                  
                              </mat-menu>
                          </div>
                          <mat-divider></mat-divider>
                      </mat-card-title>
                      <mat-card-content>
                          <!-- user detail lines-->
                          <div fxLayout="row wrap" fxLayout.lt-sm="column">
                              <div fxFlex="100" class="pr-1"><br></div>
                              <div fxFlex="100" class="pr-1 ml-1">Registro Nº: {{itemDeclaracaoImportacao?.numeroRegistro }}</div>
                              <div fxFlex="100" class="pr-1 ml-1">Data: {{itemDeclaracaoImportacao?.dataRegistro | date }}</div>
                              <div fxFlex="100" class="pr-1 ml-1">Desembaraço: {{itemDeclaracaoImportacao?.localDesembaraco }}</div>
                              <div fxFlex="100" class="pr-1 ml-1">Data: {{itemDeclaracaoImportacao?.dataDesembaraco | date }}</div> 
                          </div>
                      </mat-card-content>
                      <mat-card-actions>
                            
                     
                      </mat-card-actions>
                  </mat-card>
              </div>
              <div fxFlex="100">
                  <mat-paginator #paginator [length]="length" fxLayoutAlign="space-around center"
                      [showFirstLastButtons]="true" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                      (page)="pageEvent = setPageSizeOptions($event)">
                  </mat-paginator>
              </div>
          </div>
      </div>

  </div>

</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
      <span fxFlex></span>
      <button mat-button color="warn" type="button" (click)="close()">{{"CLOSE" | translate }}</button>
  </div>
</mat-dialog-actions>